import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'labelled-products',
  templateUrl: './labelled-products.component.html',
  styleUrls: ['./labelled-products.component.scss']
})
export class LabelledProductsComponent implements OnInit {

  @Input() products;
  
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/labelled-products/labelled-products.component.ts